/*
  Favourites (wishlist)
  Saved product handles are kept in this browser's localStorage, so shoppers don't need an account.
  Registers Alpine.store('wishlist') and Alpine.data('FavoritesPage') on alpine:init,
  so this file must load before Alpine boots (see snippets/scripts.liquid).
*/
(() => {
  const STORAGE_KEY = 'maye:favorites';

  const read = () => {
    try {
      const items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(items) ? items.filter((handle) => typeof handle === 'string') : [];
    } catch (error) {
      return [];
    }
  };

  const write = (items) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
      // Storage can be blocked (private browsing) - favourites then only last for this page view
    }
  };

  document.addEventListener('alpine:init', () => {
    const Alpine = window.Alpine;
    const strings = window.theme.favorites;

    Alpine.store('wishlist', {
      items: read(),
      announcement: '',

      get count() {
        return this.items.length;
      },

      has(handle) {
        return this.items.includes(handle);
      },

      toggle(handle, title = '') {
        if (this.has(handle)) {
          this.remove(handle, title);
        } else {
          this.add(handle, title);
        }
      },

      add(handle, title = '') {
        if (this.has(handle)) return;
        this.items = [handle, ...this.items];
        write(this.items);
        this.announce(strings.saved, title);
      },

      remove(handle, title = '') {
        this.prune(handle);
        this.announce(strings.removed, title);
      },

      // Remove without announcing, e.g. a saved product that no longer exists
      prune(handle) {
        this.items = this.items.filter((item) => item !== handle);
        write(this.items);
      },

      announce(message, title) {
        // Clear first so screen readers re-read a repeated message
        this.announcement = '';
        setTimeout(() => {
          this.announcement = message.replace('[title]', title).trim();
        }, 100);
      },
    });

    // Keep favourites in sync across open tabs
    window.addEventListener('storage', (event) => {
      if (event.key === STORAGE_KEY) Alpine.store('wishlist').items = read();
    });

    Alpine.data('FavoritesPage', () => ({
      cards: [],
      isLoading: true,

      async init() {
        await this.load();

        this.$watch('$store.wishlist.items', (items) => {
          const loaded = this.cards.map((card) => card.handle);

          if (items.some((handle) => !loaded.includes(handle))) {
            this.load();
          } else {
            this.cards = this.cards.filter((card) => items.includes(card.handle));
          }
        });
      },

      async load() {
        const handles = [...this.$store.wishlist.items];
        const cards = await Promise.all(handles.map((handle) => this.fetchCard(handle)));

        this.cards = cards.filter(Boolean);
        this.isLoading = false;
      },

      async fetchCard(handle) {
        try {
          const response = await fetch(
            `${window.theme.routes.root_url}products/${encodeURIComponent(handle)}?view=favorite-card`,
          );

          if (response.status === 404) {
            this.$store.wishlist.prune(handle);
            return null;
          }

          if (!response.ok) return null;

          return { handle, html: await response.text() };
        } catch (error) {
          return null;
        }
      },
    }));
  });
})();
